import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/IDC.png"

export function Index() {
  return (
    <Layout
      title="IDC Tech Research Conference Success with Premagic AI Photo Platform"
      description="IDC leveraged AI photo technology to boost attendee engagement and enhance analyst community interaction at technology research events."
      metaImage={ThumbnailImage}
      keywords={[
        "IDC case study, tech research events, analyst conference photos, technology research summit, IT industry analysis events, tech market research events, analyst networking events, technology conference photo sharing, tech analyst community events, IT research summit photos, technology market analysis events",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "IDC", url: "/case-study/idc/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "IDC Tech Research Conference Success with Premagic AI Photo Platform",
            "description": "IDC leveraged AI photo technology to boost attendee engagement and enhance analyst community interaction at technology research events.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.IDC} />
    </Layout>
  )
}

export default Index
